export enum RotationType {
  DISTAL = "DISTAL",
  MESIAL = "MESIAL",
}
